<template>
	<div v-html="data.settings.content" style="overflow:auto"></div>
</template>

<script>
	export default {
		props:{
			"data":Object
		}
	}
</script>